<template>
  <div class="flex-wrap hover-lighter" style="background:linear-gradient(to bottom right,var(--bg2),var(--border));border:1px solid var(--border);border-radius:3px;height:25px;font-size:12px;padding:0 5px;margin:0 10px;">
    <BaseIcon icon="lianjieliu" style="margin-right:5px;" />
    {{ flowId?'进行中':'创建流程' }}
  </div>
</template>

<script>
export default {
  props: {
    'flow-id': {
      type: String,
    },
  },
};
</script>
